import type { DraftNotebookKind } from './draftNotebookKind';

const KIND_LABEL: Record<DraftNotebookKind, string> = {
  article: 'article',
  recipe: 'recipe',
  movie: 'movie',
  event: 'event',
};

export function clusterDraftKindLabel(kind: DraftNotebookKind): string {
  return KIND_LABEL[kind];
}

/** Intro line in the generate-draft dialog (cluster count + content kind). */
export function clusterDraftGenerationIntro(clusterCount: number, kind: DraftNotebookKind): string {
  const k = KIND_LABEL[kind];
  const unit = clusterCount === 1 ? 'cluster' : 'clusters';
  return `Create a podcast episode draft from ${clusterCount} selected ${unit} to complement your ${k}. It is saved under Podcasts for editing and publishing.`;
}

/** Short hint on how generation is framed for this draft type. */
export function clusterDraftGenerationFocusLine(kind: DraftNotebookKind): string {
  switch (kind) {
    case 'article':
      return 'The model leans on narrative angles and viewpoints that support your article.';
    case 'recipe':
      return 'The model leans on ingredients, prep flow, and sensory cues from the clusters.';
    case 'movie':
      return 'The model leans on plot, talent, and release context where the clusters support it.';
    case 'event':
      return 'The model leans on timing, venue, and audience hooks for your event.';
  }
}

export function clusterDraftGenerationFooterNote(kind: DraftNotebookKind): string {
  return `AI builds a podcast episode draft as supporting material for your ${KIND_LABEL[kind]}. Length and language apply to that podcast output.`;
}

export function clusterDraftGenerationSettingsTitle(): string {
  return 'Podcast output';
}

export function clusterDraftGenerationLoadingTitle(): string {
  return 'Generating draft…';
}

export function clusterDraftGenerationLoadingBody(kind: DraftNotebookKind): string {
  return `We are creating a podcast episode draft from your clusters to complement your ${KIND_LABEL[kind]}. This may take a moment.`;
}
